// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--1VDlq"};